module.exports = __webpack_public_path__ + "img/11.0f2f68fe.png";